export default __webpack_public_path__ + "static/media/game-pagetype-index_game.98e4dd2b.svg";